(function ($, Drupal, SimpleBar) {

  function initNewsScroll(scrollable) {
    const $block = $(scrollable);
    const $mainNews = $('.block-views-blockarticle-home-premium-promo,.block-views-blockarticle-home-free-promoted')
      .find('.view-content');
    const $scrollable = $block.find('.view-content');

    // Set programmatically max-height.
    if ($mainNews) {
      console.log($mainNews);
      const height = $mainNews.first().innerHeight();
      console.log(height);
      $scrollable.css('height', height + 'px');
    }

    // Show block and apply custom scroll.
    $block.find('.content').show();
    new SimpleBar($scrollable[0], {autoHide: false});
  }

  function initScroll(scrollable) {
    const $scrollable = $(scrollable);
    new SimpleBar($scrollable[0], {autoHide: false});
  }

  /**
   * Initialize custom scrollbar.
   */
  Drupal.behaviors.scrollbar = {
    attach(context) {
      once(
        'scrollbar-news',
        '.block-views-blockarticles-most-recent-articles',
        context,
      ).forEach(initNewsScroll);

      once(
        'scrollbar',
        '.block-views-blockchat-comments-auto-refresh-block ',
        context,
      ).forEach(initScroll);
    },
  };

})(jQuery, Drupal, SimpleBar);

